/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Erc20__factory } from "./Erc20__factory";
